var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-menu",on:{"click":_vm.gotoHome}},[_c('v-icon',{staticClass:"btn-icon-back",attrs:{"large":""}},[_vm._v("mdi-arrow-left")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }